module.exports = __webpack_public_path__ + "img/activeState.9f432892.svg";